import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-membersnewsreference',
  templateUrl: './members-news-reference.component.html',
  styleUrls: ['./members-news-reference.component.css']
})
export class MembersNewsReferenceComponent implements OnInit {

  ngOnInit() { }
}
